import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_6fba6318 from 'nuxt_plugin_plugin_6fba6318' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_2d951054 from 'nuxt_plugin_plugin_2d951054' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_templatesplugin26f2225b_37d2e6fe from 'nuxt_plugin_templatesplugin26f2225b_37d2e6fe' // Source: ./templates.plugin.26f2225b.js (mode: 'client')
import nuxt_plugin_gtm_b10c26f8 from 'nuxt_plugin_gtm_b10c26f8' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_5e21f5d6 from 'nuxt_plugin_cookieuniversalnuxt_5e21f5d6' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_6fa8ddcd from 'nuxt_plugin_pluginutils_6fa8ddcd' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_422da850 from 'nuxt_plugin_pluginrouting_422da850' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_9049e2d2 from 'nuxt_plugin_pluginmain_9049e2d2' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_11c6722e from 'nuxt_plugin_axios_11c6722e' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_image_066521ae from 'nuxt_plugin_image_066521ae' // Source: ./image.js (mode: 'all')
import nuxt_plugin_googleanalytics_07d15d38 from 'nuxt_plugin_googleanalytics_07d15d38' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_vueslickcarousel_0c02c5e7 from 'nuxt_plugin_vueslickcarousel_0c02c5e7' // Source: ../plugins/vue-slick-carousel.js (mode: 'all')
import nuxt_plugin_translatable_28a9f012 from 'nuxt_plugin_translatable_28a9f012' // Source: ../plugins/translatable.js (mode: 'all')
import nuxt_plugin_vmask_6cc105c0 from 'nuxt_plugin_vmask_6cc105c0' // Source: ../plugins/v-mask.js (mode: 'all')
import nuxt_plugin_vdebounce_f9501a7a from 'nuxt_plugin_vdebounce_f9501a7a' // Source: ../plugins/v-debounce.js (mode: 'all')
import nuxt_plugin_jsonld_320ccf54 from 'nuxt_plugin_jsonld_320ccf54' // Source: ../plugins/jsonld (mode: 'all')
import nuxt_plugin_vuegtag_5e89f8ee from 'nuxt_plugin_vuegtag_5e89f8ee' // Source: ../plugins/vue-gtag.js (mode: 'all')
import nuxt_plugin_restorenonceclient_ecd2ad4c from 'nuxt_plugin_restorenonceclient_ecd2ad4c' // Source: ../plugins/restore-nonce.client.js (mode: 'client')
import nuxt_plugin_vuegooglemaps_03e21887 from 'nuxt_plugin_vuegooglemaps_03e21887' // Source: ../plugins/vue-google-maps.js (mode: 'client')
import nuxt_plugin_yandexmetrika_47338796 from 'nuxt_plugin_yandexmetrika_47338796' // Source: ../plugins/yandex-metrika.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Korzinka","htmlAttrs":{"lang":"ru"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"},{"hid":"robots","name":"robots","content":"index, follow"},{"hid":"yandex-verification","name":"yandex-verification","content":"9f69c59b02697530"}],"link":[{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffav.png"}],"script":[{"type":"text\u002Fjavascript","src":"https:\u002F\u002Funpkg.com\u002Finputmask@5.0.7\u002Fdist\u002Finputmask.js","async":true},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Flottie-web\u002F5.10.2\u002Flottie.min.js","defer":true},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002FScrollMagic\u002F2.0.8\u002FScrollMagic.min.js","defer":true},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fgsap\u002F3.11.5\u002Fgsap.min.js","defer":true},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002FScrollMagic\u002F2.0.8\u002Fplugins\u002Fanimation.gsap.js","defer":true},{"type":"application\u002Fld+json","json":{"name":"Korzinka","url":"https:\u002F\u002Fkorzinka.uz","address":{"@type":"PostalAddress","streetAddress":"ул. Кичик халка йули, д. 120","addressLocality":"Ташкент","addressRegion":"Ташкент","postalCode":"100015","addressCountry":"Узбекистан"},"contactPoint":{"@type":"ContactPoint","telephone":"+998781401414","email":"info@korzinka.uz","contactType":"General"}}},{"type":"application\u002Fld+json","json":{"@context":"http:\u002F\u002Fwww.schema.org","@type":"LocalBusiness","name":"ИП ООО «ANGLESEY FOOD»","url":"https:\u002F\u002Fkorzinka.uz","address":{"@type":"PostalAddress","streetAddress":"ул. Туроб Тула, д. 57","addressLocality":"Ташкент","addressRegion":"Ташкент","postalCode":"100066","addressCountry":"Узбекистан"},"contactPoint":{"@type":"ContactPoint","telephone":"+998781401414","email":"info@korzinka.uz","contactType":"General","image":"https:\u002F\u002Fapi.korzinka.uz\u002Fupload\u002Fmedialibrary\u002F1ed\u002Fuq7lydpaoi35i20myreiek8e64no2kqc.jpg"},"openingHours":"'Mo-Fr, 9:00−18:00, Пн-Пт, 9:00 – 18:00"}},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-NG7R4DW')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-NG7R4DW&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_6fba6318 === 'function') {
    await nuxt_plugin_plugin_6fba6318(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_2d951054 === 'function') {
    await nuxt_plugin_plugin_2d951054(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin26f2225b_37d2e6fe === 'function') {
    await nuxt_plugin_templatesplugin26f2225b_37d2e6fe(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_b10c26f8 === 'function') {
    await nuxt_plugin_gtm_b10c26f8(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_5e21f5d6 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_5e21f5d6(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_6fa8ddcd === 'function') {
    await nuxt_plugin_pluginutils_6fa8ddcd(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_422da850 === 'function') {
    await nuxt_plugin_pluginrouting_422da850(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_9049e2d2 === 'function') {
    await nuxt_plugin_pluginmain_9049e2d2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_11c6722e === 'function') {
    await nuxt_plugin_axios_11c6722e(app.context, inject)
  }

  if (typeof nuxt_plugin_image_066521ae === 'function') {
    await nuxt_plugin_image_066521ae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_07d15d38 === 'function') {
    await nuxt_plugin_googleanalytics_07d15d38(app.context, inject)
  }

  if (typeof nuxt_plugin_vueslickcarousel_0c02c5e7 === 'function') {
    await nuxt_plugin_vueslickcarousel_0c02c5e7(app.context, inject)
  }

  if (typeof nuxt_plugin_translatable_28a9f012 === 'function') {
    await nuxt_plugin_translatable_28a9f012(app.context, inject)
  }

  if (typeof nuxt_plugin_vmask_6cc105c0 === 'function') {
    await nuxt_plugin_vmask_6cc105c0(app.context, inject)
  }

  if (typeof nuxt_plugin_vdebounce_f9501a7a === 'function') {
    await nuxt_plugin_vdebounce_f9501a7a(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_320ccf54 === 'function') {
    await nuxt_plugin_jsonld_320ccf54(app.context, inject)
  }

  if (typeof nuxt_plugin_vuegtag_5e89f8ee === 'function') {
    await nuxt_plugin_vuegtag_5e89f8ee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_restorenonceclient_ecd2ad4c === 'function') {
    await nuxt_plugin_restorenonceclient_ecd2ad4c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuegooglemaps_03e21887 === 'function') {
    await nuxt_plugin_vuegooglemaps_03e21887(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_yandexmetrika_47338796 === 'function') {
    await nuxt_plugin_yandexmetrika_47338796(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
